import { useState } from "react";
import axios from "@/api/axios";
import { useSession } from "./useSession";

const useGetDetailledObservation = () => {
  const { token } = useSession();
  const [detailLoading, setDetailLoading] = useState(false);
  const [detailError, setDetailError] = useState(null);
  const [detailledData, setDetailledData] = useState(null);

  const getDetailledData = async (id) => {
    setDetailLoading(true);
    setDetailError(null);

    const url = `/api/v1/observations/${id}`;

    try {
      const response = await axios.get(url, {
        headers: {
          accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });
      setDetailledData(response.data);
      return response.data;
    } catch (err) {
      setDetailError(err);
      // **re-throw** so callers can catch
      throw err;
    } finally {
      setDetailLoading(false);
    }
  };

  return { getDetailledData, detailledData, detailLoading, detailError };
};

export default useGetDetailledObservation;
